<div class="p-medium">
  <ls-display level="1">
    <ng-content></ng-content>
  </ls-display>
</div>
<mat-divider></mat-divider>
